<h2 class="step-title">{{ title }}</h2>
<h3>
  {{ subtitle }}
</h3>
<div class="field">
  <div [ngClass]="{'control': true, 'has-icons-left': isIconTest}">
    @if (!inputModeTest) {
      <input class="input is-large email-step fontTest"
        [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && control.touched && control.errors, 'icon-style': isIconTest}"
        type="email" placeholder="Email" formControlName="email" #email (change)="snap()" autocomplete="email" name="email">
    }
    @if (isIconTest) {
      <span class="icon is-small is-left">
        <i class="fas fa-envelope"></i>
      </span>
    }

    @if (inputModeTest) {
      <input inputmode="email" class="input is-large email-step fontTest"
        [ngClass]="{'is-danger':highlightingBoxForRequiredInfo && control.touched && control.errors}"
        type="email" placeholder="Email" formControlName="email" #email (change)="snap()" autocomplete="email" name="email">
    }
  </div>

  @if (control.touched && control.errors) {
    <div class="help is-danger has-text-left">
      @if (control.errors.required) {
        <p>Email is required.</p>
      }
      @if (control.errors.email || control.errors.pattern) {
        <p>Invalid email address.</p>
      }
    </div>
  }
</div>

<button   class="button continue is-large has-shadow-small" (click)="submit()">
  {{ submitButtonText }}
  <i class="fas fa-chevron-right"></i>
</button>